/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.plan-parent', {
            // use a parent state to cache the dinghies etc.
            parent: 'board.dinghy',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY']
            },
            resolve: {
                dinghies: ['DinghyBoard', function(DinghyBoard) {
                    return DinghyBoard.query({
                        size: 99,
                        active: true,
                        sort: ['type,asc', 'id']
                    }).$promise;
                }],
                availableYears: ['$http', function($http) {
                    return $http.get('api/board/dinghies/years');
                }],
                currentProfile: ['PrincipalProfile', function(PrincipalProfile) {
                    return PrincipalProfile.identity(false);
                }],
            }
        })
        .state('board.dinghy.plan', {
            parent: 'board.dinghy.plan-parent',
            url: '/plan?timeFilter?dinghyIds',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY'],
                pageTitle: 'askApp.dinghy.detail.title'
            },
            views: {
                'dinghy@board.dinghy': {
                    templateUrl: 'app/board/dinghy/plan/dinghy-plan.html',
                    controller: 'DinghyPlanController',
                    controllerAs: 'vm'
                }
            },
            params: {
                timeFilter: {
                    value: 'active',
                    squash: true
                },
                dinghyIds: {
                    value: '0',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        timeFilter: $stateParams.timeFilter,
                        dinghyIds: $stateParams.dinghyIds.split(',')
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
